import React, { useCallback, useRef } from 'react'
import './LabelCell.css'

export default function LabelCell({children, switchMode, setPos, isLocked=false, tabIx = '9', isSensitive=false, ...rest}) {
  // console.log('[CellLabel Enter] [children: %s]', children);
  
  const {placeholder} = rest;
  const contentRef = useRef(null);
  const wrapperRef = useRef(null);

  //------  Handle Focus  ------
  //
  const handleFocus = useCallback((e) => {
    // console.log('[handleFocus: %s]', e.target);
    if (isLocked) {
      contentRef.current.blur();
    }
    setPos(0);
    switchMode();
  }, [isLocked, setPos, switchMode]);

  
  //------  Update Pos  ------
  //
  const updatePos = useCallback((e, isOutside = false) => {
    const clicked = (e.clientX && e.clientX > 0) ? true : false;
    
    if (isLocked) {
      return;
    }    

    if (clicked) {
      const clickPosition = e.clientX - contentRef.current.getBoundingClientRect().left;
      const textLen       = contentRef.current.textContent.length;        
      const textWidth     = contentRef.current.offsetWidth;
      const ratio = clickPosition / textWidth;
      const position = isOutside ? textWidth : Math.round(ratio * textLen);       
      setPos(position);
    }
    else {
      // console.log('Focus Only. Pos 0');
      setPos(0);
    }

    switchMode();

  }, [isLocked, setPos, switchMode]);

  //------  Handle Content Click  ------
  //
  const handleContentClick = useCallback((e) => {
    // console.log('[handleContentClick: %s]', e.target);
    e.stopPropagation();    
    updatePos(e);
  }, [updatePos]);


  //------  Handle Buffer Click  ------
  //
  const handleBufferClick = useCallback((e) => {
    // console.log('[handleBufferClick: %s]', e.target);
    e.stopPropagation();    
    updatePos(e, true);
  }, [updatePos]);




  // ------  Render  ------

  const styleName = children ? 'labelCell' : 'labelCellPlaceholder';

  return (
    <div className={styleName} ref={wrapperRef} {...rest}>
      {!isLocked && <div onFocus={handleFocus} tabIndex={tabIx}/>}
      <div className='labelCell-content' ref={contentRef} onClick={handleContentClick}>
        {children || placeholder}
      </div>
      <div className='labelCell-pad' onClick={handleBufferClick} />
    </div>
  )
}
